import { UpdateElements, OnContentLoaded } from './modules/event-calendar.js';

const EVENTS_CALENDAR_URL = `${window.location.protocol}//${window.location.host}/events/calendar`;
const options = { year: 'numeric', month: 'numeric', day: 'numeric' };

let searchParams = new URLSearchParams(window.location.search);
let date = searchParams.get('date');
let calendar = searchParams.get('calendar');

let eventCalendar = document.querySelector('[data-event-calendar]');

const replaceCalendar = (newDate, newCalendar) => {
    if (newCalendar === null) newCalendar = '';
    if (newDate === null) newDate = new Date().toLocaleDateString("en-US", options);

    // Update state
    date = newDate;
    calendar = newCalendar;

    // Update query
    const newQuery = `?${date != null ? 'date=' + date + '&' : ''}${calendar != '' ? 'calendar=' + calendar : ''}`;
    history.replaceState(
        null, "",
        newQuery
    );

    // Get the currently active calendar view and update the new calendar's 'default' view
    const activeButtons = [...document.querySelectorAll('.Calendar__Switch--cal-toggle[data-active]')];
    const currentView = activeButtons[0]?.dataset.calview;
    eventCalendar.dataset.defaultview = currentView;

    // Build URL for calendar fetch
    const url = `${EVENTS_CALENDAR_URL}?date=${encodeURIComponent(date)}&calendar=${calendar}`;
    
    // Fetch calendar for requested parameters
    fetch(url, { method: 'GET' })
        .then((response) => response.text())
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newCalendar = doc.querySelector("[data-event-calendar]");

            // Set the new calendar content
            eventCalendar.innerHTML = newCalendar.innerHTML;

            // Run the init
            UpdateElements();
            OnContentLoaded();

            configureActions(eventCalendar);
        })
        .catch(error => {
            console.error(error.message);
        });
}

const onClickAction = (event) => {
    event.preventDefault();
    var el = event.currentTarget;
    
    var targetDate = el.getAttribute("data-event-calendar-date");
    var targetCalendar = el.getAttribute("data-event-calendar-calendar");

    // If the target calendar is currently active, stop filtering
    if (targetCalendar == calendar) {
        targetCalendar = '';
    }

    // Use current values if none present
    if (targetDate === null) targetDate = date;
    if (targetCalendar === null) targetCalendar = calendar;

    replaceCalendar(targetDate, targetCalendar);
}

const configureActions = (eventCalendar) => {
    const dateLinks = document.querySelectorAll('[data-event-calendar-link]');

    dateLinks.forEach((link) => {
        link.addEventListener('click', onClickAction)
    })
}

if (eventCalendar) {
    // Set up event actions
    configureActions(eventCalendar);
}